module.exports = __webpack_public_path__ + "static/media/villa-azul-4.5c02e55c.png";